import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';

export const initialDataResolver = () => {
  const navigationService = inject(NavigationService);

  // The one thing the first screen cannot be drawn without: the menu comes from this response.
  return navigationService.get();
};
